<div class="signature-flow-overlay">
    <div class="signature-flow-container">
        <div class="signature-flow-body">
            
            <!-- Icon -->
            <ra-square-icon [icon]="'arrow-left'" (click)="close.emit()" />

            <!-- Titlte -->
            <h1 class="ra-header-s title-signature-flow">{{ 'document.preview.signatureFlow.title' | translate }}</h1>
            <p class="ra-label-s content-secondary">{{ 'document.preview.signatureFlow.subtitle' | translate }}</p>

            <!-- name -->
            <div class="container-input-name">
                <ra-input 
                    class="input-name"
                    [label]="'common.name' | translate" 
                    [placeholder]="'document.edit.userSignature.namePlaceholder' | translate" 
                    [formControl]="name" 
                />
            </div>

            <!-- Lista de opções de assinaturas -->
            <div class="container-options-signatures">
                @for (option of signatureOptions; track option.fontFamily) {
                    <button
                        type="button"
                        class="signature-option"
                        [class.selected]="selectedFontFamily === option.fontFamily"
                        (click)="selectSignature(option.fontFamily)"
                    >
                        <span
                            class="signature-preview"
                            [style.fontFamily]="option.fontFamily"
                        >
                            {{ signaturePreview() }}
                        </span>
                    </button>
                }
            </div>

        </div>

        <!-- Button continue fixed -->
        <div class="container-continue-fixed">
            <ra-button 
                [label]="'document.edit.userSignature.continue' | translate" 
                [type]="'primary'" 
                [disabled]="!name.valid || signLoading()" 
                [loading]="signLoading()"
                (click)="handleContinue()"
            />
        </div>
    </div>

    @if (showConfirmation()) {
        <div class="confirm-signature-overlay" (click)="closeConfirmation()">
            <div class="confirm-signature-container" (click)="$event.stopPropagation()">
                <div class="confirm-signature-header">
                    <button
                        type="button"
                        class="confirm-signature-close"
                        [disabled]="signLoading()"
                        (click)="closeConfirmation()"
                    >
                        <ra-icon icon="close" varColor="currentColor" [size]="16" />
                    </button>
                </div>

                <div class="confirm-signature-content">
                    <ra-icon class="confirm-signature-icon" icon="pen-draw" varColor="currentColor" [size]="32" />

                    <h2 class="ra-header-s confirm-signature-title">{{ 'document.edit.userSignature.confirmTitle' | translate }}</h2>

                    <p class="ra-label-s content-secondary confirm-signature-message">
                        {{ 'document.edit.userSignature.confirmMessage' | translate }}
                    </p>
                </div>

                <div class="confirm-signature-actions">
                    <ra-button
                        [label]="'document.edit.userSignature.confirmButton' | translate"
                        [type]="'primary'"
                        [loading]="signLoading()"
                        [disabled]="signLoading()"
                        (click)="confirmSignature()"
                    />
                </div>
            </div>
        </div>
    }
</div>
